import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset, MergeSource } from '../../decorators';
import { AccountContactMergeData, AccountContactMergeSchema, AccountMergeData, AccountMergeSchema, AttachmentsMergeData, AttachmentsMergeSchema, CompanyMergeData, CompanyMergeSchema, ContactFullMergeData, ContactFullMergeSchema, ContactMergeSchema, EmployeeMergeData, EmployeeMergeSchema, JobAssetsMergeData, JobAssetsMergeSchema, JobContactLinksMergeData, JobContactLinksMergeSchema, JobIncludeItemsMergeData, JobIncludeItemsMergeDataSchema, JobMergeData, JobMergeSchema, JobSiteMergeData, JobSiteMergeSchema, JobStagesMergeData, JobStagesMergeDataSchema, OtherMergeData, OtherMergeDataSchema, TaskArrayMergeData, TaskArrayMergeDataSchema, TimesheetArrayMergeData, TimesheetArrayMergeDataSchema } from '../data';
import { EquipmentArrayMergeData, EquipmentArrayMergeDataSchema } from '../data/equipment.merge.data';
import { JobPrimaryContactMergeData, JobPrimaryContactMergeSchema } from '../data/job.primary.contact.merge.data';

@MergeDataset({
    entity: ActivityEntityName.Job
})
export class JobMergeDataset {

    @MergeSource({
        schema: JobMergeSchema
    })
    job: JobMergeData;

    @MergeSource({
        schema: JobStagesMergeDataSchema
    })
    jobStage: JobStagesMergeData;

    @MergeSource({
        schema: AccountMergeSchema
    })
    jobCustomer: AccountMergeData;

    @MergeSource({
        schema: AccountContactMergeSchema
    })
    jobCustomerContact: AccountContactMergeData;

    @MergeSource({
        schema: JobPrimaryContactMergeSchema,
        ignoreCustomFields: true,
    })
    jobPrimaryContact: JobPrimaryContactMergeData;

    @MergeSource({
        schema: JobSiteMergeSchema
    })
    jobSite: JobSiteMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    jobBillingCompany: CompanyMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    jobFieldSupervisor: EmployeeMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    jobOwner: EmployeeMergeData;

    @MergeSource({
        schema: JobContactLinksMergeSchema,
        displayName: 'Job Contacts'
    })
    jobContact: JobContactLinksMergeData;

    @MergeSource({
        schema: JobAssetsMergeSchema,
        ignoreCustomFields: true,
    })
    jobAsset: JobAssetsMergeData;

    @MergeSource({
        schema: JobIncludeItemsMergeDataSchema,
        ignoreCustomFields: true,
    })
    jobItems: JobIncludeItemsMergeData;

    @MergeSource({
        schema: OtherMergeDataSchema,
    })
    other: OtherMergeData;

    @MergeSource({
        schema: AttachmentsMergeSchema,
        ignoreCustomFields: true,
    })
    files?: AttachmentsMergeData;

    @MergeSource({
        schema: TaskArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    jobTasks: TaskArrayMergeData;

    @MergeSource({
        schema: TimesheetArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    jobTimesheets: TimesheetArrayMergeData;

    @MergeSource({
        schema: EquipmentArrayMergeDataSchema,
        ignoreCustomFields: true,
    })
    jobEquipments: EquipmentArrayMergeData;
}